// extracted by mini-css-extract-plugin
export default {"projectFieldModuleBox":"FieldModuleBox_projectFieldModuleBox__9re70","selected":"FieldModuleBox_selected__EDVZX"};